export default {"src":"/_next/static/media/ic-delete.c18becaa.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};